import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Dropdown } from 'react-bootstrap';

// import images
import verticalicon from '../.././../images/verticalicon.svg';
import ToastMessage from '../../ToastMessage';
import { API_BASE_URL, getBearerToken } from '../../../functions';
import axios from 'axios';
import UserProfile from '../../Modals/UserProfile';

const UsersTRLoop = (props) => {
    const [toastMessage, setToastMessage] = useState(null);
    const [show, setShow] = useState();



    const handalDelet = (e, id) => {
        axios.get(`${API_BASE_URL}/deletemysector/${e}`, {
            headers: {
                'Authorization': `Bearer ${getBearerToken()}`
            }
        }).then(response => {
            // Handle the response data
            setToastMessage({ type: 'success', message: 'My Sector Deleted successfully!', show: 'show' });
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }).catch(error => {
            // Handle errors
            console.error(error);
        });

    };

    const handalShow = (e) => {
        e.preventDefault()
        setShow(true)
    }
    return (
        <>
            {toastMessage && <ToastMessage type={toastMessage.type} message={toastMessage.message} show={toastMessage.show} />}
            <tr>
                <td>
                    <Link to={'#'} className={'d-flex align-items-center text-decoration-none'} onClick={handalShow}>
                        <div className='AllPhoto'><img className={'img-fluid'} src={props.usericon} alt={'icon'} /></div>
                        {/* <h5 className={'ms-3 fontsize14 fontweight600 blacktext'}>{props.userTitle}</h5> */}
                    </Link>
                </td>
                <td>{props.userTitle}</td>
                <td>{props.email}</td>
                <td><Badge bg={''} className={'p-2 py-1 RGBAcolor3bg greentext'}>Active</Badge></td>
                <td>
                    <Dropdown className={''} align={'end'} autoClose="outside">
                        <Dropdown.Toggle className={''} variant={''} id="dropdown-autoclose-outside"><img className={'img-fluid'} src={verticalicon} alt={'icon'} /></Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item className={'dropdown-item'} onClick={(e) => handalDelet(props?.id)}>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </td>
            </tr>
        </>
    )
}

export default UsersTRLoop;